const { BlazeError } = require('@blaze-cms/core-errors');

const DEFAULT_KEY = 'default';

function basicItemTypeHandler(typeName, options = {}) {
  const { requiredProperties = [], throwErrorIfNotFound = false } = options;
  const types = new Map();

  function get(key = DEFAULT_KEY) {
    if (throwErrorIfNotFound && !has(key)) {
      throw new BlazeError(`${typeName} "${key}" does not exist`);
    }
    return types.get(key);
  }

  function getDefault() {
    return types.get(DEFAULT_KEY);
  }

  function has(key) {
    return types.has(key);
  }

  function getAll() {
    return Array.from(types.values());
  }

  function getKeys() {
    return Array.from(types.keys());
  }

  function add(typeOptions) {
    validate(typeOptions);
    const { key } = typeOptions;
    types.set(key, typeOptions);
  }

  function setDefault(defaultTypeKey) {
    if (!types.has(defaultTypeKey)) {
      return;
    }

    const defaultType = get(defaultTypeKey);
    types.set(DEFAULT_KEY, defaultType);
  }

  function validate(typeOptions) {
    const { key } = typeOptions;
    if (!key) throw new BlazeError(`A ${typeName} type requires a key`);
    if (types.has(key)) {
      throw new BlazeError(`A ${typeName} type with the key ${key} has been already added`);
    }

    requiredProperties.forEach(({ property, type }) => {
      if (!isValidType(typeOptions[property], type)) {
        throw new BlazeError(
          `A ${typeName} type requires a "${property}" property that is a ${type}`
        );
      }
    });
  }

  function isValidType(propertyType, type) {
    if (type === 'array') {
      return Array.isArray(propertyType);
    }
    // eslint-disable-next-line valid-typeof
    return typeof propertyType === type;
  }

  return { add, get, getAll, getKeys, has, setDefault, getDefault };
}

module.exports = basicItemTypeHandler;
